import React, { FC } from 'react';
import { Wechat } from '@hfzq/otter-react';
import { initSensors } from './analytics/helper/sa';
import { ErrorBoundary } from './components/error-boundary';
import { ErrorPage } from './page/error-page';
import { RouteProvider } from './routes';
import { utilServer_querySignatureByPostUsingPOST } from './apis';
import { useForceRepaint } from './helper/hooks/use-force-repaint';
import { loadPdfView } from './components/pdf-view';

/**
 * 添加redux 示例代码
 * 
 * @example
const App: FC = () => (
  <ReduxProvider>
    <RouteProvider />
  </ReduxProvider>
);
 */
const App: FC = () => {
  useForceRepaint();
  React.useEffect(() => {
    // 初始化神策sdk
    initSensors({
      show_log: process.env.REACT_APP_SENSORS_DEBUG === 'true',
    });
    loadPdfView(true);
  }, []);
  return (
    <Wechat
      enableShareConfig
      enableLaunchAppConfig
      openAppId={process.env.REACT_APP_WX_APPID as string}
      getSignature={() => utilServer_querySignatureByPostUsingPOST({ url: window.location.href })}
    >
      <ErrorBoundary fallback={<ErrorPage />}>
        <RouteProvider />
      </ErrorBoundary>
    </Wechat>
  );
};

export default App;
